module.exports = __webpack_public_path__ + "static/img/工作动态@2x.8b6c8b0.webp";


//////////////////
// WEBPACK FOOTER
// ./static/webp2/工作动态@2x.webp
// module id = Tivo
// module chunks = 1